export function validateCPF(string: string) {
  string = string.replace(/[^0-9]+/g, '');

  if (string.length === 0) {
    return true;
  }

  if (string.length < 11) {
    return false;
  }

  if (string === '00000000000') {
    return false;
  }

  let sum = 0;
  for (let i = 1; i <= 9; i++) {
    sum += Number(string.substring(i - 1, i)) * (11 - i);
  }
  let rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11) {
    rest = 0;
  }
  if (rest !== Number(string.substring(9, 10))) {
    return false;
  }
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += Number(string.substring(i - 1, i)) * (12 - i);
  }
  rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11) {
    rest = 0;
  }

  return rest === Number(string.substring(10, 11));
}
